/* Rio behaviour tracking (Oct 7 2026). Sends a few plain events to Google Analytics through the
   gtag already on the page, so the dashboard can answer "why" questions:
   - rio_cta_click: which button and which page section people click to buy or learn more
   - rio_section_view: whether people reach the danger band, the solution band, Why Rio chapters
   - rio_compare_drag: someone used the before/after slider
   - rio_faq_open: which FAQ question was opened
   - rio_outbound: every click that leaves riorouter.com, with the destination site and its type
     (checker, competitor or retailer, social, support docs, app store, other)
   No personal data: only page path, section type, button text and question text.
   gtag respects the site's consent settings; if gtag is missing, nothing is sent. */
(function () {
  if (window.__rioTrack) return;
  window.__rioTrack = true;
  var path = location.pathname;
  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    var p = params || {};
    p.page_path = path;
    window.gtag('event', name, p);
  }
  function clean(s, n) { return String(s || '').replace(/\s+/g, ' ').trim().slice(0, n || 60); }
  function sectionOf(el) {
    var s = el && el.closest && el.closest('.shopify-section');
    if (!s || !s.id) return 'unknown';
    // shopify-section-template--123__rio_relief_home -> rio_relief_home
    return s.id.replace(/^shopify-section-/, '').replace(/^.*__/, '').slice(0, 40);
  }

  // Buy and learn-more clicks.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a, button');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var text = clean(a.textContent);
    // Any link that leaves riorouter.com: record the destination site and what kind of site it is.
    var host = '';
    try { var u = new URL(href, location.href); if (/^https?:$/.test(u.protocol) && u.hostname !== location.hostname && !/(^|\.)riorouter\.com$/i.test(u.hostname)) host = u.hostname.replace(/^www\./, ''); } catch (err) {}
    if (host) {
      var kind = /ismyroutersafe\.com$/i.test(host) ? 'rio_checker'
        : /(eero|amazon|amzn|netgear|tp-link|tplink|firewalla|ubiquiti|ui\.com|gl-inet|asus|linksys|google\.com\/(nest|store)|store\.google|bestbuy|walmart|nordvpn|expressvpn|surfshark)/i.test(host + (u && u.pathname || '')) ? 'competitor_or_retailer'
        : /(facebook|instagram|twitter|x\.com|youtube|linkedin|tiktok|reddit)/i.test(host) ? 'social'
        : /(drive\.google|docs\.google)/i.test(host) ? 'support_docs'
        : /(apps\.apple|play\.google)/i.test(host) ? 'app_store'
        : 'other';
      send('rio_outbound', { link_text: text, destination: host.slice(0, 60), destination_type: kind, section: sectionOf(a) });
      return;
    }
    var isBuy = /\/products\/|\/cart|\/checkouts?\b|pricing/i.test(href) || a.name === 'add' || /add to cart|buy|order|get rio/i.test(text);
    if (isBuy) send('rio_cta_click', { link_text: text, link_url: href.slice(0, 80), section: sectionOf(a) });
  }, true);

  // Section views: danger band, solution band, compare slider, Why Rio chapters, FAQ.
  if ('IntersectionObserver' in window) {
    var seen = {};
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var key = en.target.getAttribute('data-rio-track-name');
        if (seen[key]) return;
        seen[key] = 1;
        io.unobserve(en.target);
        send('rio_section_view', { section_name: key, section: sectionOf(en.target) });
      });
    }, { threshold: 0.35 });
    var targets = [
      ['.rsg-pains--threat', 'danger_band'], ['.rsg-relief', 'solution_band'], ['.rsg-pair', 'compare_slider'],
      ['.rsg-faq', 'faq'], ['.rsg-honest', 'does_doesnt_table'],
      ['.rwk-first', 'why_router_is_computer'], ['.rwk-eve:not(.rwk-eve--rewind)', 'why_evening'],
      ['.rwk-rew-intro', 'why_rewind'], ['.rwk-truth', 'why_noticed_none'], ['.rwk-dawn', 'why_what_works'], ['.rwk-rio', 'why_rio_offer']
    ];
    function watch() {
      targets.forEach(function (t) {
        document.querySelectorAll(t[0]).forEach(function (el, i) {
          if (el.hasAttribute('data-rio-track-name')) return;
          el.setAttribute('data-rio-track-name', t[1] + (i ? '_' + (i + 1) : ''));
          io.observe(el);
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  }

  // Before/after slider used (once per page view).
  var dragged = false;
  document.addEventListener('input', function (e) {
    if (dragged || !e.target.classList || !e.target.classList.contains('rsg-pair__range')) return;
    dragged = true;
    send('rio_compare_drag', { section: sectionOf(e.target) });
  }, true);

  // FAQ opens.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open || !d.closest('.rsg-faq, .faq, [class*="faq"]')) return;
    var q = d.querySelector('summary');
    send('rio_faq_open', { question: clean(q && q.textContent, 80), section: sectionOf(d) });
  }, true);
})();
